import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { faBuilding, faCodeBranch, faComputer } from "@fortawesome/free-solid-svg-icons";
// COMPONENTS
import DashboardSystemDetails from "./DashboardSystemDetails";
import DrawerRowDivider from "../components/drawer/DrawerRowDivider";
import DashboardVersion from "./DashboardVersion";
import DashboardOrganizationDetails from "./DashboardOrganizationDetails";

function Template() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div style={{ marginTop: "-35px" }}>
      {/** ************************************************* */}
      {/** COMPONENT DRAWER DIVIDER */}
      <DrawerRowDivider icon={faBuilding} title={t("general.organization")} />
      <DashboardOrganizationDetails />
      {/** ************************************************* */}
      {/** COMPONENT DRAWER DIVIDER */}
      <DrawerRowDivider icon={faComputer} title={t("general.systemDetails")} />
      <DashboardSystemDetails />
      {/** ************************************************* */}
      {/** COMPONENT DRAWER DIVIDER */}
      <DrawerRowDivider icon={faCodeBranch} title={t("general.version")} />
      <DashboardVersion />
    </div>
  );
}

export default Template;
